import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChargePointListLocationCell } from './charge-point-list-location.cell';
import { ChargePointListLocationHeader } from './charge-point-list-location.header';

export const ChargePointListLocationColumn: IdentifiedColumnDef<
  GatewayChargePointModel,
  GatewayChargePointModel['location']
> = {
  enableSorting: false,
  header: ChargePointListLocationHeader,
  cell: ChargePointListLocationCell,
  meta: { maxWidth: '140px' },
};
